module.exports = __webpack_public_path__ + "img/no_employee.a065edc8.svg";